import { Box } from "ui/box/box";
import { Divider } from "ui/divider/divider";
import { IconButton } from "ui/icon-button/icon-button";
import { mergeSx } from "ui/merge-sx";
import { TextField } from "ui/text-field/text-field";

import {
  ACTIONS_SX,
  CONTROL_SX,
  DIVIDER_SX,
} from "ui/inline-editable-field/inline-editable-field.styles";
import { type InlineEditableFieldProps } from "ui/inline-editable-field/inline-editable-field.types";
import { useInlineEditableField } from "ui/inline-editable-field/use-inline-editable-field";

import Icons from "assets";

const SAVE_LABEL = "Save";
const CANCEL_LABEL = "Cancel";

export const InlineEditableField = ({
  ref,
  size = "medium",
  isEditing = true,
  readActions,
  onSave,
  onCancel,
  isSaving = false,
  canSave = true,
  disabled,
  onKeyDown,
  controlSx,
  ...rest
}: InlineEditableFieldProps) => {
  const { isSaveDisabled, isCancelDisabled, handleKeyDown, handleActionMouseDown } =
    useInlineEditableField({
      isEditing,
      isSaving,
      canSave,
      disabled,
      onSave,
      onCancel,
      onKeyDown,
    });

  return (
    <TextField
      ref={ref}
      {...rest}
      size={size}
      disabled={disabled}
      onKeyDown={handleKeyDown}
      controlSx={mergeSx(CONTROL_SX[size], controlSx)}
      inputActions={
        isEditing ? (
          <Box sx={ACTIONS_SX[size]}>
            <IconButton
              variant="text"
              aria-label={SAVE_LABEL}
              disabled={isSaveDisabled}
              loading={isSaving}
              onMouseDown={handleActionMouseDown}
              onClick={onSave}>
              <Icons.Checkmark />
            </IconButton>
            <Divider orientation="vertical" sx={DIVIDER_SX} />
            <IconButton
              variant="text"
              aria-label={CANCEL_LABEL}
              disabled={isCancelDisabled}
              onMouseDown={handleActionMouseDown}
              onClick={onCancel}>
              <Icons.QuickTipClose />
            </IconButton>
          </Box>
        ) : (
          readActions
        )
      }
    />
  );
};
